import ArtikelData from "../request/artikel_data"

export default class BPArtikelHinzufuegenRequest {
  id: string
  artikelData: ArtikelData
}
